import React, { useState } from "react";
import { ReactComponent as IconCloseCircle } from "../../../build/images/platformnps/closecircle.svg";
import Button from "../Button";
import MicroModal from "micromodal";
import { connection_platform } from "../../../services/api";
import axios from "axios";
import { deleteEvaluationCall } from "../../../actions";

// let url_connection = `${connection_platform.type_connect}:${localStorage.getItem("pathname")}:${localStorage.getItem("port")}`
// let url_connection = `https://cloud.ingweb.com.br:8080`
let url_connection = `${connection_platform.type_connect}://${connection_platform.ip_intern}:${connection_platform.port_backend_intern}`;

const DeletedEvaluationCallCenterModal = ({
  modalTitle,
  treatmentData,
  getlistDeal = null,
  onCloseDrawer,
}) => {
  const deletedQuestionEvaluation = async () => {
    MicroModal.close("modal-component-accept-evaluation-modal");
    await deleteEvaluationCall(treatmentData.id_atendimento);
    /*
    await axios.get(
      `${url_connection}/conn/delete-evaluation?idatendimento=${treatmentData.id_atendimento}`
    );
    */
    onCloseDrawer();
    const hasGetlistDeal = !!getlistDeal;
    if (hasGetlistDeal) {
      getlistDeal();
    }
  };

  const closeModal = () => {
    MicroModal.close("modal-component-deleted-evaluation-modal");
  };

  function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return "";

    const ddd = phoneNumber.substring(0, 2);
    const number = phoneNumber.substring(2);

    return `(${ddd}) ${number}`;
  }

  return (
    <div
      className="modal micromodal-slide"
      id="modal-component-deleted-evaluation-modal"
      aria-hidden="true"
    >
      <div className={`modal__overlay`} aria-modal="true" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          style={{ padding: "24px", borderRadius: "8px" }}
        >
          <div className="modal-component__general-accept">
            <div className="modal-component__general__header-danger">
              <span>{modalTitle}</span>
              <div className="modal_close" onClick={() => closeModal()}>
                <IconCloseCircle />
              </div>
            </div>
            <div className="modal-component__general__body">
              <div className="modal-component__general__body-title">
                <span>
                  Ao aceitar, você confirma que a resposta foi tratada.
                </span>
              </div>
              <div className="modal-component__general__body-contents">
                <div>
                  Cliente:
                  <span> {treatmentData.nome_cliente}</span>
                </div>
                <div>
                  Perfil:
                  <span
                    className={
                      treatmentData.nota_nps >= 1 && treatmentData.nota_nps <= 6
                        ? "Detrator"
                        : treatmentData.nota_nps === 7 ||
                          treatmentData.nota_nps === 8
                        ? "Neutro"
                        : "Promotor"
                    }
                  >
                    {treatmentData.nota_nps >= 1 && treatmentData.nota_nps <= 6
                      ? " Detrator"
                      : treatmentData.nota_nps === 7 ||
                        treatmentData.nota_nps === 8
                      ? " Neutro"
                      : " Promotor"}
                  </span>
                </div>
                <div>
                  Nota:
                  <span
                    className={
                      treatmentData.nota_nps >= 1 && treatmentData.nota_nps <= 6
                        ? "Detrator"
                        : treatmentData.nota_nps === 7 ||
                          treatmentData.nota_nps === 8
                        ? "Neutro"
                        : "Promotor"
                    }
                  >
                    {" " + treatmentData.nota_nps}
                  </span>
                </div>
                <div>
                  Atendimento:
                  <span> {treatmentData.id_atendimento}</span>
                </div>
                <div>
                  Serviço:
                  <span> {treatmentData.service}</span>
                </div>
                <div>
                  Data e hora:
                  <span> {treatmentData.data_atendimento}</span>
                </div>
                <div>
                  Telefone:
                  <span>
                    {" "}
                    {formatPhoneNumber(treatmentData.numero_cliente)}
                  </span>
                </div>
              </div>
            </div>
            <div className="modal-component__general__body-actions">
              <Button
                label="Cancelar"
                theme="light"
                action={() => closeModal()}
              />
              <Button
                label="Excluir"
                theme="danger-2"
                action={() => {
                  deletedQuestionEvaluation();
                  closeModal();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletedEvaluationCallCenterModal;
